export default __webpack_public_path__ + "static/media/empty-mailbox.6054a0bb.svg";